import { useDecision } from '@optimizely/react-sdk';
import { FeatureFlagVariable } from 'v2/core/clients/featureFlag/flags';
import { FeatureFlagOptions } from 'v2/core/clients/featureFlag/types';
import { QueryStatus } from 'v2/core/repository/edge-server/types';
import { Variation } from '.';

const useOptimizelyFeatureVariable = <T>(
  fflag: FeatureFlagVariable<T>,
  options?: FeatureFlagOptions,
): [QueryStatus, T] => {
  const [decision, ClientReady, didTimeout] = useDecision(fflag.name, {
    autoUpdate: options?.autoUpdate,
  });
  // if fetching timed out, fallback
  if (didTimeout) {
    return [QueryStatus.SUCCESS_COMPLETED, fflag.fallback];
  }

  // if in progress, fallback
  if (!ClientReady) {
    return [QueryStatus.IN_PROGRESS, fflag.fallback];
  }

  const enabled = decision.variationKey !== Variation.Off;
  const value =
    fflag.variableName in decision.variables && enabled
      ? (decision.variables[fflag.variableName] as T)
      : fflag.fallback;

  return [QueryStatus.SUCCESS_COMPLETED, value];
};
export default useOptimizelyFeatureVariable;
